/**
 * About Us nav submenu (UserHeader + AuthHeader).
 */
export const ABOUT_SUBMENU_ITEMS = [
  {
    id: "company",
    title: "Company",
    desc: "Our mission, vision, and what we stand for",
    to: "/about_us/company",
    iconSrcDark: "/images/company_icon_menu.svg",
    iconSrcLight: "/images/company_icon_menu_light.svg",
  },
  {
    id: "team",
    title: "Team",
    desc: "Meet the leadership behind Arab Global",
    to: "/about_us/team",
    iconSrcDark: "/images/team_menu_icon.svg",
    iconSrcLight: "/images/team_menu_icon_light.svg",
  },
];
